/**
 * OVERRIDE Edit.jsx
 * REASON: This theme introduces the concept of "Caption" and uses `figure`
 * tag for the image.
 */

import ImageEdit from '../../../../../../components/Blocks/Image/Edit';

export default ImageEdit;
